var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomizedProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F66A3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7832 37V31.25H28.45V33.3H37V34.9668H28.45V37H26.7832ZM19 34.9668V33.3H25.1168V34.9668H19ZM23.45 30.8668V28.8333H19V27.1667H23.45V25.1H25.1168V30.8668H23.45ZM26.7832 28.8333V27.1667H37V28.8333H26.7832ZM30.8833 24.75V19H32.55V21.0333H37V22.7H32.55V24.75H30.8833ZM19 22.7V21.0333H29.2168V22.7H19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizedProfile);
export default __webpack_public_path__ + "static/media/customized_profile.9c5927b781c29c2506c3da3490859fcc.svg";
export { ForwardRef as ReactComponent };